import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  isRounded: boolean;
};

export const Container = styled.div<Props>(
  ({isRounded}: Props) => css`
    position: relative;
    height: 100%;

    ${isRounded &&
    css`
      border-radius: 5px;
      overflow: hidden;
    `}
  `
);
